import { Box, Typography, styled } from '@mui/material';
import LayoutModal from '../../../LayoutModal';
import BaseButton from '../../../common/BaseButton';
import { useState } from 'react';
import api from '../../../../utils/api';
import { useConfig } from '../../../../Hooks/useConfig';
import { getCookie, removeCookie, setCookie } from '../../../../utils/cookies';
import {
  useHistory,
  useLocation,
} from 'react-router-dom/cjs/react-router-dom.min';
import { useAuthStatus } from '../../../../store/auth/useAuthStatus';
import { useTranslation } from 'react-i18next';

const ModalValidationEmailTitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.spacing(7),
  marginBottom: theme.spacing(4),
  fontWeight: 600,
  [theme.breakpoints.down('md')]: {
    fontSize: theme.spacing(5),
  },
}));

const ModalValidationEmailText = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(4),
  [theme.breakpoints.down('md')]: {
    fontSize: theme.spacing(3.5),
  },
}));

const ModalFailureBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  padding: '8px 24px',
  gap: '8px',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  alignSelf: 'stretch',
  borderRadius: '5px',
  background: '#F7D4D3',
}));

const LogoutText = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(4),
  fontSize: theme.spacing(3),
  span: {
    color:
      theme.palette.mode === 'dark'
        ? theme.palette.secondary.secondary_70
        : theme.palette.secondary.main,
    fontSize: theme.spacing(3),
    cursor: 'pointer',
  },
}));

const ModalValidationEmail = ({ open, email, status }) => {
  const { baseDomain } = useConfig();
  const history = useHistory();
  const { setToken } = useAuthStatus();
  const { t } = useTranslation();
  const route = useLocation();

  const [loadingButton, setLoadingButton] = useState(false);

  const resendEmail = async () => {
    setLoadingButton(true);
    const resendEmailReq = await api.call({
      name: 'resendEmail',
      data: {
        email: email,
      },
    });
    setLoadingButton(false);
  };

  const Logout = async () => {
    removeCookie('token', baseDomain);
    let theme = getCookie('darkMode'); //localStorage.getItem("darkMode");
    localStorage.clear();
    // localStorage.setItem("darkMode", theme);
    setCookie('darkMode', theme, 34560000, baseDomain);
    setToken('');
    await history.push('/login');
  };
  return (
    <LayoutModal
      iconWidth="64px"
      icon="/static/img/icon/valitationEmail.png"
      sx={{ padding: (theme) => theme.spacing(6, 14) }}
      open={open}
      statusBoxType={route.search.replace('?', '')}
    >
      <ModalValidationEmailTitle>
        {t('verifay_email.please_verify')}
      </ModalValidationEmailTitle>
      <ModalValidationEmailText>
        {t('verifay_email.verify_text')}{' '}
        <Typography sx={{ fontWeight: 700 }} component={'span'}>
          {email ? email : null}
        </Typography>
      </ModalValidationEmailText>
      <ModalValidationEmailText>
        {t('verifay_email.just_click')}{' '}
        <Typography sx={{ fontWeight: 700 }} component={'span'}>
          {t('verifay_email.check_spam')}
        </Typography>{' '}
        {t('verifay_email.folder')}.
      </ModalValidationEmailText>
      <ModalValidationEmailText>
        {t('verifay_email.no_problem')}.{' '}
      </ModalValidationEmailText>
      <BaseButton
        disabled={loadingButton}
        sx={{ width: '100%', mt: 4 }}
        onClick={() => resendEmail(email)}
      >
        {t('verifay_email.resend_email')}
      </BaseButton>
      <LogoutText>
        {t('verifay_email.wrong_email')}?{' '}
        <Typography onClick={Logout} component={'span'}>
          {t('verifay_email.sign_out')}
        </Typography>
      </LogoutText>
    </LayoutModal>
  );
};
export default ModalValidationEmail;
